"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlyCalendar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const typography_1 = require("../../shared/typography");
const faAngleLeft_1 = require("@fortawesome/pro-regular-svg-icons/faAngleLeft");
const faAngleRight_1 = require("@fortawesome/pro-regular-svg-icons/faAngleRight");
const hooks_1 = require("../../shared/hooks");
const MonthlyCalendar = ({ date, onLeftClick, onRightClick, disabled }) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    return ((0, jsx_runtime_1.jsxs)(Calendar, { disabled: disabled, children: [(0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: faAngleLeft_1.faAngleLeft, size: isMobile ? "1x" : "lg", onClick: onLeftClick }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H2, { children: date }, void 0), (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: faAngleRight_1.faAngleRight, size: isMobile ? "1x" : "lg", onClick: onRightClick, color: disabled ? "lighten-grey" : "grey" }, void 0)] }, void 0));
};
exports.MonthlyCalendar = MonthlyCalendar;
const Calendar = styled_components_1.default.div `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.silverLighten40};
  display: flex;
  justify-content: space-between;
  height: 4rem;

  h2 {
    font-size: 1.5rem;
    margin-bottom: 0;
    text-transform: capitalize;
  }

  & > div {
    cursor: pointer;
    padding: ${({ theme }) => `${theme.spacings.m}`};
    width: unset;
  }

  & > div:last-of-type {
    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    height: 3rem;

    h2 {
      font-size: 1rem;
    }
  }
`;
//# sourceMappingURL=MonthlyCalendar.js.map